import { SwitchDirective } from "./switch.directive";
import {
  Component,
  Input,
  ContentChildren,
  QueryList,
  AfterContentInit
} from "@angular/core";

@Component({
  selector: "[switch]",
  templateUrl: "./switch.component.html"
})
export class SwitchComponent implements AfterContentInit {
  @Input() size = "switch-sm";
  @Input() color = "switch-secondary";
  @Input() dataKey = "";
  @Input() labelName = "";
  @Input("labelRightLocation") rightLocation = true;
  @Input("switchStyle") style: Object = new Object();
  @Input() breakLine = false;

  @ContentChildren(SwitchDirective)
  inputs: QueryList<SwitchDirective>;

  ngAfterContentInit() {
    this.inputs.forEach(input => {
      input.renderer.setElementClass(
        input.el.nativeElement,
        "switch-input",
        true
      );
    });
  }
}
